import { memo } from 'react';

import { Avatar, Typography } from '@/ui';
import { formatNumericCalendarDate, getAge, parseIsoDate } from '@/utils/dates';
import formatPersonName from '@/utils/formatPersonName';

import type { Props } from './types';

const joinPresent = (values: (string | null | undefined)[]) => values.filter(Boolean).join(' • ');

const PersonBasicInfoHeader = ({ person }: Props) => {
  const name = formatPersonName({ person, withPronouns: false });
  const demographics = joinPresent([
    person.birthday &&
      `${formatNumericCalendarDate(person.birthday)} (${getAge(parseIsoDate(person.birthday))})`,
    person.sex,
    person.pronouns
  ]);
  const location = joinPresent([person.jurisdiction?.name, person.time_zone]);

  return (
    <span className="flex items-center gap-4">
      <Avatar
        name={formatPersonName({ person, withNickname: false, withPronouns: false })}
        src={person.profile_image_url}
        size="xl"
        className="mp-sensitive"
      />
      <span className="mp-sensitive min-w-0">
        <Typography variant="heading" as="span" className="block">
          {name}
        </Typography>
        {demographics && (
          <Typography as="span" muted weight="normal" className="block">
            {demographics}
          </Typography>
        )}
        {location && (
          <Typography as="span" muted weight="normal" className="block truncate" title={location}>
            {location}
          </Typography>
        )}
      </span>
    </span>
  );
};

export default memo(PersonBasicInfoHeader);
